var map = {
	"./apple.png": 9667,
	"./cronometer.webp": 8013,
	"./dexcom.png": 6996,
	"./eight.webp": 9307,
	"./fitbit.webp": 5855,
	"./garmin.webp": 4515,
	"./google.png": 2553,
	"./hipaa.jpg": 9893,
	"./metriport-logo.png": 2276,
	"./myfitnesspal.webp": 6604,
	"./oura.webp": 1856,
	"./peloton.webp": 8383,
	"./polar.webp": 1922,
	"./signingoogle.png": 1877,
	"./soc2.png": 7621,
	"./suunto.webp": 1966,
	"./wahoo.webp": 8114,
	"./whoop.png": 4819,
	"./withings.png": 8051
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;